<template>
  <vs-popup
    class="look-direct-rule-dialog"
    :title="title"
    :active.sync="isDialogShow"
  >
    <div class="dialog-content">
      <el-form
        ref="form"
        label-position="top"
      >
        <el-form-item
          label=""
          prop="levelName"
        >
          <div slot="label">
            {{$t('Direct_customer_class_name')}}
          </div>
          <el-input
            v-model="directRuleInfo.levelName"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          v-for="(item,index) in directRuleInfo.custGroupList"
          :key="index"
        >
          <div slot="label">
            {{ item.groupType }} {{$t('Group')}}
          </div>
          <el-input
            v-model="item.desc"
            disabled
          ></el-input>
        </el-form-item>
        <commission-rule-group
          :is-disabeld="isDisabeld"
          :rule-data="ruleList"
        ></commission-rule-group>
      </el-form>
    </div>
    <!-- <div class="footer-sidebar">
      <vs-button
        @click="closeHandle"
        color="primary"
      >{{$t('Confirm')}}</vs-button>
    </div> -->
  </vs-popup>
</template>

<script>
import commissionRuleGroup from "@/components/agent/propagandas/commissionRuleGroup";
import { mapGetters } from 'vuex'
export default {
  name: "lookDirectRuleDialog",
  components:{
    commissionRuleGroup,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    directRuleInfo:{
      type: Object,
      default(){
        return {
          levelName: '',
          custGroupList: [],
        }
      }
    },
    ruleList: {
      type: Array,
      default(){
        return [];
      }
    }
  },
  data() {
    let _this = this;
    return {
      title: _this.$t('View_rebate_rules'),
      isDisabeld: true,
      isDialogShow: this.dialogShow,
    }
  },
  watch: {
    dialogShow(newVal) {
      this.isDialogShow = newVal;
    },
    isDialogShow(newVal) {
      if (!newVal) {
        this.$emit('close');
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo','themeColor']),
  },
  methods: {
    close(){
      this.isDialogShow = false;
    },
    closeHandle() {
      this.close();
    },
    submitHandle(){
      this.close();
    },
    cancelHandle(){
      this.close();
    }
  },
}
</script>

<style lang="scss">
.look-direct-rule-dialog {
  .vs-popup {
    width: 1280px;
    max-width: 95vw;
    min-width: 320px;
    @media (max-width: 768px) {
      width: 95vw;
    }
    .vs-popup--header {
      .vs-popup--title {
        h3 {
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
    .vs-popup--content {
      padding: 0;
      max-height: 70vh;
      overflow-y: auto;
    }
  }
  .dialog-content {
    padding: 20px;
  }
  .footer-sidebar {
    padding: 15px 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-top: 1px solid #e8e8e8;
  }
}
</style>
